import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "./OnBoardingScreen.css";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import onBoard_anime_video_1 from "../../animations/onBorading_anime_1.mp4";
import onBoard_anime_video_2 from "../../animations/onBorading_anime_2.mp4";
import onBoard_anime_video_3 from "../../animations/onBorading_anime_3.mp4";
import onBoard_anime_video_4 from "../../animations/onBorading_anime_4.mp4";
function OnBoardingScreen(props) {
  const [currentSlideNumber, setCurrentSlideNumber] = useState(0);
  const [displayAnimation, setDisplayAnimation] = useState(false);
  const [leftClick, setLeftClick] = useState(false);
  const [rightClick, setRightClick] = useState(false);
  const onBoardingMessage = [
    "Get Personalized Instruction from AI Agents",
    "Engage with Multi-modal learning Experiences",
    "Show your work digitally using a stylus device",
    "Receive instant feedback and Accelerate your progress",
  ];

  useEffect(() => {
    setDisplayAnimation(true);
    setTimeout(() => {
      setDisplayAnimation(false);
      setLeftClick(false);
      setRightClick(false);
    }, 1000);
    setTimeout(() => {
      if (currentSlideNumber < 3) {
        setRightClick(true);
        setCurrentSlideNumber((currentSlideNumber) => currentSlideNumber + 1);
      } else {
        setLeftClick(true);
        setCurrentSlideNumber(0);
      }
    }, 4000);
  }, [currentSlideNumber]);

  function boardingLeftArrow() {
    return (
      <div
        className="boarding-left-arrow"
        onClick={() => {
          if (currentSlideNumber > 0) {
            setLeftClick(true);
            setCurrentSlideNumber(
              (currentSlideNumber) => currentSlideNumber - 1
            );
          }
        }}
      >
        <ArrowBackIosRoundedIcon style={{ width: "25px", height: "25px" }} />
      </div>
    );
  }

  function boardingRightArrow() {
    return (
      <div
        className="boarding-right-arrow"
        onClick={() => {
          if (currentSlideNumber < 3) {
            setRightClick(true);
            setCurrentSlideNumber(
              (currentSlideNumber) => currentSlideNumber + 1
            );
          }
        }}
      >
        <ArrowForwardIosRoundedIcon style={{ width: "25px", height: "25px" }} />
      </div>
    );
  }

  function renderAnime() {
    return (
      <span>
        {currentSlideNumber === 0 ? (
          <video key={"video1"} width="100%" height="100%" autoPlay loop muted>
            <source src={onBoard_anime_video_1} type="video/mp4" />
          </video>
        ) : currentSlideNumber === 1 ? (
          <video key={"video2"} width="100%" height="100%" autoPlay loop muted>
            <source src={onBoard_anime_video_2} type="video/mp4" />
          </video>
        ) : currentSlideNumber === 2 ? (
          <video key={"video3"} width="100%" height="100%" autoPlay loop muted>
            <source src={onBoard_anime_video_3} type="video/mp4" />
          </video>
        ) : (
          <video key={"video4"} width="100%" height="100%" autoPlay loop muted>
            <source src={onBoard_anime_video_4} type="video/mp4" />
          </video>
        )}
      </span>
    );
  }

  return (
    <div className="boarding-main-container">
      {boardingLeftArrow()}
      {boardingRightArrow()}
      <div className="boarding-container-area">
        <div className="brand-label-container">
          <span className="login-brand-knovo">knovo</span>
          <span className="login-brand-backpack">Backpack</span>
        </div>
        <div className="boarding-container-1">
          <div className="boarding-container">
            <div
              className="boarding-label-container"
              style={{
                animation: displayAnimation
                  ? rightClick
                    ? "moveToLeft 100ms ease-in-out"
                    : leftClick
                    ? "moveToRight 100ms ease-in-out"
                    : "none"
                  : "none",
              }}
            >
              <p className="boarding-label">
                {onBoardingMessage[currentSlideNumber]}
              </p>
            </div>
            <div
              className="boarding-anim-container"
              style={{
                animation: displayAnimation
                  ? rightClick
                    ? "moveToLeft 100ms ease-in-out"
                    : leftClick
                    ? "moveToRight 100ms ease-in-out"
                    : "none"
                  : "none",
              }}
            >
              {renderAnime()}
            </div>
          </div>
        </div>
        <div className="boarding-pagination-container">
          {onBoardingMessage.map((item, index) => {
            return (
              <div
                key={index.toString()}
                className="pagination-dot"
                style={{
                  backgroundColor:
                    currentSlideNumber === index
                      ? "#000000"
                      : "rgba(0, 0, 0, 0.1)",
                }}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(OnBoardingScreen);
